import { render } from "./post-smtp-log-action-menu.vue?vue&type=template&id=383c7fd0&scoped=true"
import script from "./post-smtp-log-action-menu.vue?vue&type=script&lang=js"
export * from "./post-smtp-log-action-menu.vue?vue&type=script&lang=js"

import "./post-smtp-log-action-menu.vue?vue&type=style&index=0&id=383c7fd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383c7fd0"]])

export default __exports__